import { useEffect } from "react";

const DEFAULT_DESC =
    "Chesterton — counsel for landowners, family businesses, and closely-held enterprises. Estate planning, real estate, and business law.";

function upsertMeta(attr, key, content) {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}='${key}']`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function upsertLink(rel, href) {
    let el = document.head.querySelector(`link[rel='${rel}']`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

function upsertJsonLd(id, json) {
    let el = document.getElementById(id);
    if (!el) {
        el = document.createElement("script");
        el.id = id;
        el.type = "application/ld+json";
        document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(json);
}

export function useSEO({ title, description, path, schema }) {
    useEffect(() => {
        const fullTitle = title
            ? `${title} | Chesterton`
            : "Chesterton — Counsel for Landowners and Family Businesses";
        document.title = fullTitle;
        const desc = description || DEFAULT_DESC;
        upsertMeta("name", "description", desc);
        upsertMeta("name", "keywords",
            "estate planning attorney, wills and trusts, powers of attorney, real estate law, title services, LLC formation, business law, closely-held business counsel, farm succession");
        upsertMeta("property", "og:title", fullTitle);
        upsertMeta("property", "og:description", desc);
        upsertMeta("property", "og:type", "website");
        upsertMeta("property", "og:site_name", "Chesterton");
        upsertMeta("name", "twitter:card", "summary_large_image");
        upsertMeta("name", "twitter:title", fullTitle);
        upsertMeta("name", "twitter:description", desc);

        const url = `${window.location.origin}${path || window.location.pathname}`;
        upsertMeta("property", "og:url", url);
        upsertLink("canonical", url);

        if (schema) upsertJsonLd("page-jsonld", schema);
    }, [title, description, path, schema]);
}

export const ORGANIZATION_SCHEMA = {
    "@context": "https://schema.org",
    "@type": "LegalService",
    name: "Chesterton",
    description: DEFAULT_DESC,
    url: typeof window !== "undefined" ? window.location.origin : "https://chesterton.law",
    telephone: "+1-901-641-2532",
    email: "info@chesterton.law",
    sameAs: []
};
